import axios, { AxiosResponse } from 'axios'
import { ValidateResult, postalCodeValidator } from 'utilities/validators'

interface PostalCodeResult {
  prefcode: string
  address: string
}

/**
 * 郵便番号辞書API zipcloud
 * @param postalCode 郵便番号
 * @param completed 完了コールバック
 * @returns 住所情報
 */
const postalCodeLibrary = async (postalCode: string, completed: (postalCodeResult: PostalCodeResult) => void) => {
  if (postalCodeValidator(postalCode) === ValidateResult.Valid) {
    const url = 'https://zipcloud.ibsnet.co.jp/api/search'
    const params = { zipcode: postalCode }
    await axios.get(url, { params }).then((response: AxiosResponse) => {
      if (response.data.results) {
        const result = response.data.results[0]
        completed({ prefcode: result.prefcode, address: `${result.address2}${result.address3}` })
      }
    })
  }
}

export default postalCodeLibrary
